import { DisplayPosition } from '@/type/display-position';
import { getDateFormatSetterSnippet, getMixedSetterSnippet, } from '../setter-snippet';
export default {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
    ],
    title: '日期范围选择器',
    componentName: 'CnDateRangePickerPro',
    getPrototypeList: () => {
        return [
            {
                name: 'outputFormat',
                title: '输出格式',
                display: 'inline',
                setter: getMixedSetterSnippet({
                    setters: [
                        {
                            title: '快捷选择',
                            componentName: 'SelectSetter',
                            props: {
                                options: [
                                    {
                                        label: '时间戳',
                                        value: '',
                                    },
                                    {
                                        label: 'YYYY',
                                        value: 'YYYY',
                                    },
                                    {
                                        label: 'YYYY-MM',
                                        value: 'YYYY-MM',
                                    },
                                    {
                                        label: 'YYYY-MM-DD',
                                        value: 'YYYY-MM-DD',
                                    },
                                    {
                                        label: 'YYYY-MM-DD HH',
                                        value: 'YYYY-MM-DD HH',
                                    },
                                    {
                                        label: 'YYYY-MM-DD HH:mm',
                                        value: 'YYYY-MM-DD HH:mm',
                                    },
                                    {
                                        label: 'YYYY-MM-DD HH:mm:ss',
                                        value: 'YYYY-MM-DD HH:mm:ss',
                                    },
                                ],
                            },
                        },
                        {
                            componentName: 'StringSetter',
                            title: '手动设置',
                        },
                    ],
                }),
            },
            getDateFormatSetterSnippet(),
            // getDatePrecisionSetterSnippet()
            // {
            //   name: 'showTime',
            //   title: '显示时间',
            //   display: 'inline',
            //   setter: 'BoolSetter',
            // },
        ];
    },
};
